import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaches/cco/$slug/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/organizations/$slug",
      params: { slug: params.slug },
      statusCode: 301,
      throw: true,
    });
  },
  component: () => null,
});
